module.exports = __webpack_public_path__ + "img/symbol_2.9a9401a4.png";